// Single source of truth for the scheduling location color-coding
// (Lakeville / HLDC), shared by the Calendar tab and the Visual drag-grid.
// Do not fork these colors.
//
// Each location carries the CalendarSystem chip treatment: `fill` (light tint
// background), `text` (mid-tone label/text), and `bar`/`dot` (full-strength
// accent for the left bar, headers, and dots). Make-up is not a per-location
// color — it's a dashed `#ed7749` outline modifier (MAKEUP_OUTLINE) layered on
// top of the location styling.
export const LOCATIONS = [
	{
		value: 'Lakeville',
		name: 'Lakeville',
		fill: '#f1f8fe',
		text: '#1565a6',
		bar: '#1d83d4',
		dot: '#1d83d4',
	},
	{
		value: 'HLDC',
		name: 'Headline',
		fill: '#fdf2f7',
		text: '#b03f78',
		bar: '#e0699a',
		dot: '#e0699a',
	},
];

// Make-up lesson modifier (not a location color): a dashed outline on the chip.
export const MAKEUP_OUTLINE = '#ed7749';

// Calendar v2 event-type accents (group class / rehearsal / recital). These are
// a SEPARATE axis from the location colors above — events carry their own venue
// (recitals) or a Lakeville/HLDC location (group class / rehearsal), but on the
// grid they're colored by TYPE so they read distinctly from one-on-one lessons.
// Chosen to stay clear of Lakeville blue, Headline pink, make-up orange, and the
// CAL_CHROME teal. Same chip treatment shape as LOCATIONS (fill/text/bar/dot)
// plus a FontAwesome glyph (fa-sharp, no emoji — per house rule).
export const EVENT_TYPES = [
	{
		value: 'groupClass',
		name: 'Group Class',
		icon: 'fa-users',
		fill: '#f4f1fb',
		text: '#5e4a9e',
		bar: '#8b6fc4',
		dot: '#8b6fc4',
	},
	{
		value: 'rehearsal',
		name: 'Rehearsal',
		icon: 'fa-masks-theater',
		fill: '#eff1fa',
		text: '#41529e',
		bar: '#5b6bb5',
		dot: '#5b6bb5',
	},
	{
		value: 'recital',
		name: 'Recital',
		icon: 'fa-star',
		fill: '#fbf6ea',
		text: '#8a6713',
		bar: '#c79a3a',
		dot: '#c79a3a',
	},
];

export const getEventColor = (type) =>
	EVENT_TYPES.find((t) => t.value === type) || EVENT_TYPES[0];

// Shared CalendarSystem chrome tokens (today highlight + grid surfaces).
export const CAL_CHROME = {
	todayBg: '#eef7f4',
	todayText: '#3a8f86', // also the "now" line + dot
	cellBorder: '#ece7e0',
	outBg: '#faf8f5',
	monthHeadBg: '#faf6f1',
	headerLine: '#ece7e0',
	// Season closure days (holiday / break) — a muted neutral tint + label.
	// Recital days are NOT colored with this: they reuse the EVENT_TYPES recital
	// gold above so they read as an attendable event, not a plain closure.
	closedBg: '#f3efe9',
	closedText: '#8c8577',
	// Flex / reserve days still hold lessons; a subtle staff-only tag flags them.
	flexText: '#9aa2b1',
};

export const getLocationColor = (location) =>
	LOCATIONS.find((l) => l.value === location) || LOCATIONS[0];
